import type { FaqItem } from '../types/offer'

export const bibleFaqs: FaqItem[] = [
  {
    id: 'que-recibo',
    question: '¿Qué recibo exactamente?',
    answer:
      'Seis documentos PDF: la guía principal, Command Console, Action Sequence Scripts, Hook Library, Commercial & Agency Rights y la guía de acceso a Skool. También recibes acceso a la comunidad. Es un producto digital, no un libro físico ni un curso grabado.'
  },
  {
    id: 'comenzando',
    question: '¿Me sirve si estoy comenzando?',
    answer:
      'Puedes estudiar los principios y adaptar los ejemplos a tu ritmo. Te resultará más fácil aplicarlos si ya sabes generar una imagen o un video en alguna herramienta de IA. No incluye tutoriales de uso paso a paso de cada plataforma.'
  },
  {
    id: 'herramientas',
    question: '¿Necesito pagar herramientas aparte?',
    answer:
      'El precio cubre el material y el acceso a Skool. La herramienta que elijas puede ofrecer pruebas, créditos gratuitos o planes de pago. Algunas técnicas también requieren edición. Comprueba sus límites y costos antes de producir.'
  },
  {
    id: 'resultados',
    question: '¿Voy a obtener exactamente los resultados del video?',
    answer:
      'Los ejemplos muestran posibilidades creativas, no un resultado garantizado. La plataforma, el modelo, las referencias, los ajustes y la edición influyen en el resultado. Es normal necesitar varias pruebas.'
  },
  {
    id: 'imagenes-videos',
    question: '¿Sirve para imágenes y para videos?',
    answer:
      'Sí. El contenido aborda prompts de imagen, composición, ideas de ganchos y planificación de secuencias de video. Algunas propuestas requieren combinar generación y edición.'
  },
  {
    id: 'skool',
    question: '¿Qué incluye el acceso a Skool?',
    answer:
      'Acceso al espacio de comunidad para compartir trabajos e intercambiar ideas. No se incluyen clases programadas, mentorías individuales, tutoriales semanales ni un tiempo de respuesta garantizado.'
  },
  {
    id: 'clientes',
    question: '¿Puedo aplicar los prompts a trabajos para clientes?',
    answer:
      'El bono comercial autoriza el uso de los prompts del material para crear visuales como servicio. Debes revisar por separado las condiciones de la herramienta y los derechos de imágenes, marcas y otros recursos que uses. No se ofrece aquí una autorización para revender estos PDF.'
  },
  {
    id: 'garantia',
    question: '¿Cómo funciona la garantía?',
    answer:
      'Tienes siete días desde la compra para solicitar la devolución del importe del producto, sin preguntas, por el canal de soporte de tu confirmación de compra.'
  }
]
